import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getEntry } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getFocusedViewMemberThreadId } from '../../focused-view-member/selectors/getFocusedViewMemberThreadId';
const getIndexedAsyncThreadListMemberDetails = get('threadListMemberDetails');
export const getFocusedThreadDetails = createSelector([getFocusedViewMemberThreadId, getIndexedAsyncThreadListMemberDetails], (threadId, indexedAsyncDetails) => {
  return threadId ? getData(getEntry(threadId, indexedAsyncDetails)) : null;
});